import React from "react";
import { useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import Modal from "react-modal";

export const UnAuthModal = (props) => {
  let subtitle;
  const history = useNavigate();

  function afterOpenModalAuth() {
    subtitle.style.color = "#f00";
  }
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      borderRadius: "15px",
    },
  };

  const handleLogout = () => {
    secureLocalStorage.removeItem("email");
    secureLocalStorage.removeItem("token");
    secureLocalStorage.removeItem("first_name");
    secureLocalStorage.removeItem("last_name");
    secureLocalStorage.removeItem('authModal')
    history("/");
  };
  const modalIsOpenAuth = secureLocalStorage.getItem('authModal')
  return (
    <div className="deleteAccountMain">
      <Modal
        isOpen={modalIsOpenAuth}
        onAfterOpen={afterOpenModalAuth}
        onRequestClose={props.closeModalAuth}
        style={customStyles}
        contentLabel="Example Modal"
      >
        <div className="delModelHeader">
          <h2>Unauthenticated</h2>
          <div class="horizontal-line"></div>
          <p>Sorry, your account has been disabled.</p>
          <div className="modal-button">
            <button
              onClick={() => handleLogout()}
              className="delAccountOkButton bg-danger d-flex align-items-center justify-content-center"
            >
              Logout
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

